/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Lead } from 'types/entities/Lead'
import { UiTableCell, UiTableRow } from 'components/Ui/UiTable'

interface EditCompanyModalLeadItemProps {
    lead: Lead
    onClick: (lead: Lead) => void
}

const EditCompanyModalLeadItem: React.FC<EditCompanyModalLeadItemProps> = ({
    lead,
    onClick,
}) => {
    return (
        <UiTableRow
            className="EditCompanyModalLeadItem"
            key={`${lead.id}`}
            onClick={() => onClick(lead)}
        >
            <UiTableCell>{`${lead.id}`}</UiTableCell>
            <UiTableCell>
                {lead.name || <span className="text-gray-400">-</span>}
            </UiTableCell>
            <UiTableCell>{lead.status}</UiTableCell>
            <UiTableCell>{lead.category}</UiTableCell>
        </UiTableRow>
    )
}

export default EditCompanyModalLeadItem
